import React from 'react'
import { InputField } from '../../components/ReactHooksFormFields/inputField';

function URIFields({ control, errors, remove, isLoading, fields, innerIndex }) {
  return (
    <div className="flex gap-2">
      <div className="flex-1">
        <InputField
          control={control}
          name={`records.${innerIndex}.redirect_uris`}
          isDisabled={false}
          title={`FHIR URI ${innerIndex + 1}`}
          rules={{
            required: {
              value: true,
              message: "FHIR URI is required",
            },
            pattern: {
              value:
                /^(?:https?:\/\/)?(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}(?::\d{1,5})?(?:\/\S*)?$/,
              message: "Invalid FHIR URI format",
            },
          }}
          errors={errors}
        />
      </div>
      {fields.length > 1 && (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            remove(innerIndex);
          }}
          className="text-red-500 text-xl font-bold py-2 px-3 mt-6 rounded hover:bg-red-50 transition"
          disabled={isLoading}
          title="Remove URI"
        >
          ×
        </button>
      )}
    </div>
  )
}

export default URIFields